import "../InviteAndResponseRow.css";

export default function InviteAndResponseRow({
  row,
  isExpanded,
  onToggleExpand,
  onShowResponse,
  onContact,
  onCopyLink,
  handleSmsClick,
  handleEmailClick,
  sendingSmsIds,
  sendingEmailIds,
  formatDateTime,
  hasContactInfo,
  getDisplayName,
}) {
  const isSendingSms = sendingSmsIds.includes(row.id);
  const isSendingEmail = sendingEmailIds.includes(row.id);
  const isSending = isSendingSms || isSendingEmail;

  const isAnswered = row.answered;
  const isPhoneInvite = row.inviteType === "phone";

  return (
    <div
      className="inviteRowCard"
      style={{
        background: isAnswered ? "#eef6ee" : "#f3eddc",
        border: isExpanded ? "2px solid rgb(221 221 221 / 87%)" : "none",
        boxShadow: isExpanded ? "rgb(82 82 82 / 20%) 1px 1px 5px 1px" : "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isExpanded ? "column" : "row",
          gap: isExpanded ? 0 : "1.2em",
        }}
      >
        <div className="pillWrapper">
          {row.customerName ? (
            <strong style={{ fontSize: "1.05em" }}>
              {getDisplayName(row)}
            </strong>
          ) : (
            <span>via tele.</span>
          )}

          <span
            style={{
              padding: "0.2em 0.6em",
              borderRadius: 999,
              background: isAnswered ? "#76f076" : "#cab98e",
              fontSize: "0.9em",
              fontWeight: 600,
            }}
          >
            {isAnswered ? "Besvarad" : "Ej besvarad"}
          </span>

          <span
            style={{
              padding: "0.2em 0.6em",
              borderRadius: 999,
              background: isPhoneInvite ? "#bae3f0" : "#c9a9f3",
              border: "1px solid #d7d7d7",
              fontSize: "0.9em",
            }}
          >
            {isPhoneInvite ? "Telefonintervju" : "Webbenkät"}
          </span>

          {row.preferPhone && (
            <span
              style={{
                padding: "0.2em 0.6em",
                borderRadius: 999,
                background: "#f38925",
                border: "1px solid #e74e11",
                fontSize: "0.9em",
                color: "#000",
              }}
            >
              Vill bli uppringd
            </span>
          )}
        </div>

        <div className="infoWrapper">
          {row.inviteCreatedDate ? (
            <span>
              <strong>Inbjudan skapad:</strong>{" "}
              {row.inviteCreatedDate
                ? row.inviteCreatedDate.toLocaleDateString("sv-SE")
                : ""}
            </span>
          ) : null}

          {isAnswered ? (
            <span>
              <strong>Svarad:</strong>{" "}
              {row.answeredDate
                ? row.answeredDate.toLocaleDateString("sv-SE")
                : "-"}
            </span>
          ) : (
            <span>
              <strong>Senast öppnad:</strong>{" "}
              {row.lastOpenedAt ? formatDateTime(row.lastOpenedAt) : "-"}
            </span>
          )}
        </div>
      </div>
      {!isExpanded && (
        <button className="toggleDetailsBtn" onClick={onToggleExpand}>
          ▼
        </button>
      )}

      {isExpanded && (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="innerRowRight">
              {row.inviteLink && !isAnswered && (
                <div className="iconWrapper">
                  <button
                    className="iconBtn"
                    title="Kopiera länk"
                    onClick={() => onCopyLink(row.inviteLink)}
                  >
                    📋
                  </button>

                  <a
                    href={row.inviteLink}
                    target="_blank"
                    rel="noreferrer"
                    className="iconBtn"
                    title="Öppna enkät"
                  >
                    🔗
                  </a>

                  <button
                    className="iconBtn"
                    style={{
                      opacity: isSending ? 0.5 : 1,
                      cursor: isSending ? "not-allowed" : "pointer",
                    }}
                    title={
                      row.smsSentCount > 0
                        ? `SMS redan skickat ${row.smsSentCount} gång(er)`
                        : "Skicka SMS"
                    }
                    disabled={isSending}
                    onClick={() => handleSmsClick(row)}
                  >
                    📱
                  </button>

                  <button
                    className="iconBtn"
                    style={{
                      opacity: isSending ? 0.5 : 1,
                      cursor: isSending ? "not-allowed" : "pointer",
                    }}
                    title={
                      row.emailSentCount > 0
                        ? `E-post redan skickat ${row.emailSentCount} gång(er)`
                        : "Skicka e-post"
                    }
                    disabled={isSending}
                    onClick={() => handleEmailClick(row)}
                  >
                    ✉️
                  </button>
                </div>
              )}

              {/* SMS / E-post skickat */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  minWidth: 160,
                  padding: 5,
                  margin: 5,
                  backgroundColor: "#ffffffe1",
                  borderRadius: 10,
                  border: "3px solid #FFF",
                }}
              >
                {row.inviteLink && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    {row.smsSentCount > 0 && (
                      <>
                        <span
                          style={{
                            fontSize: "0.9em",
                            color: "#555",
                          }}
                        >
                          SMS skickat ({row.smsSentCount})
                        </span>
                        <span
                          style={{
                            fontSize: "0.9em",
                            color: "#555",
                          }}
                        >
                          {row.lastSmsSentAt
                            ? `Senast ${formatDateTime(row.lastSmsSentAt)}`
                            : ""}
                        </span>
                      </>
                    )}
                    {row.emailSentCount > 0 && (
                      <>
                        <span
                          style={{
                            fontSize: "0.9em",
                            color: "#555",
                          }}
                        >
                          E-post skickat ({row.emailSentCount})
                        </span>
                        <span
                          style={{
                            fontSize: "0.9em",
                            color: "#555",
                          }}
                        >
                          {row.lastEmailSentAt
                            ? `Senast ${formatDateTime(row.lastEmailSentAt)}`
                            : ""}
                        </span>
                      </>
                    )}
                    {!row.emailSentCount &&
                      !row.smsSentCount &&
                      !isPhoneInvite && (
                        <>
                          <span
                            style={{
                              fontSize: "0.9em",
                              color: "#c74848",
                              fontWeight: "bold",
                            }}
                          >
                            Ingen inbjudan skickad!
                          </span>
                        </>
                      )}
                    
                  </div>
                )}
                {!row.emailSentCount &&
                      !row.smsSentCount && isPhoneInvite && (
                      <>
                        <span
                          style={{
                            fontSize: "0.9em",
                            color: "#555",
                          }}
                        >
                          Telefonintervju
                        </span>
                      </>
                    )}
              </div>
            </div>

            {/* {isAnswered && (
              <div>
                {row.matchedInvite ? row.matchedInvite.emailSentCount : 0}
              </div>
            )} */}
          </div>
          {isExpanded && (
            <button className="toggleDetailsBtn" onClick={onToggleExpand}>
              ▲
            </button>
          )}
          <div className="innerRowWrapper">
            <div className="innerRow">
              {row.customerId && (
                <span>
                  <strong>KundID:</strong> {row.customerId}
                </span>
              )}
              <span>
                <strong>Handläggare:</strong> {row.employeeId || "-"}
              </span>
              <span>
                <strong>Kontor:</strong> {row.officeId || "-"}
              </span>
            </div>

            <div className="customerBtnWrapper">
              {isAnswered && row.customerId && (
                <button
                  onClick={() => onShowResponse(row.customerId)}
                  className="customerBtn"
                  style={{ minWidth: 100 }}
                >
                  Visa svar
                </button>
              )}

              {hasContactInfo(row) ? (
                <button
                  className="customerBtn"
                  style={{ minWidth: 100 }}
                  onClick={() => onContact(row)}
                >
                  Kontakt
                </button>
              ) : (
                <span
                  style={{
                    display: "flex",
                    padding: "1.1em 1em",
                    borderRadius: 6,
                    background: "rgb(151, 207, 153)",
                    fontSize: "0.6em",
                    fontWeight: "600",
                    color: "rgb(102, 102, 102)",
                    justifyContent: "center",
                    height: "100%",
                    alignSelf: "center",
                    minWidth: 100,
                  }}
                >
                  Ingen kontaktinfo
                </span>
              )}
            </div>
          </div>

          {row.createdBy ? (
            <div className="innerRowBottom">
              <strong>Gjord av: {row.createdBy}</strong>
            </div>
          ) : null}
        </>
      )}

      {isSending && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 10,
            zIndex: 10,
          }}
        >
          <div className="spinner" />
        </div>
      )}
    </div>
  );
}
